import { enqueueSnackbar } from "notistack";

type ApiResponse = {
    status?: "success" | "error" | "warning" | "info";
    message?: string;
};

export const showApiMessage = (
    res?: ApiResponse,
    successFallback = "Η ενέργεια ολοκληρώθηκε με επιτυχία",
    errorFallback = "Παρουσιάστηκε σφάλμα"
) => {
    if (!res) {
        enqueueSnackbar("Δεν ελήφθη απάντηση από τον server", { variant: "error" });
        return false;
    }

    if (res.status === "success") {
        enqueueSnackbar(res.message || successFallback, { variant: "success" });
        return true;
    }

    enqueueSnackbar(res.message || errorFallback, { variant: "error" });
    return false;
};
